/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import DateFnsUtils from "@date-io/date-fns";
import viLocale from "date-fns/locale/vi";
import dateformat from "dateformat";

//--- Action
import * as userManagementAction from "../../../redux/store/user-management/user-management.store";

//--- Material Control
import {
  DialogActions,
  TextareaAutosize,
  Button,
  TextField,
  DialogContent,
  DialogTitle,
  Dialog,
  makeStyles,
  Typography,
  IconButton,
  Select,
  MenuItem,
} from "@material-ui/core";

import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";

//--- Material Icon
import CloseIcon from "@material-ui/icons/Close";
import SaveIcon from "@material-ui/icons/Save";

//--- Notifications
import ShowNotification from "../../../components/react-notifications/react-notifications";
import { NotificationMessageType } from "../../../utils/configuration";
import * as viVN from "../../../language/vi-VN.json";

//--- DropzoneArea
import { DropzoneArea } from "material-ui-dropzone";
import * as config from "../../../utils/configuration";
import * as configCommon from "../../../common/config";

const useStyles = makeStyles((theme) => ({
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
}));

export default function EditUserManagement(props) {
  const classes = useStyles();

  const {
    isOpen,
    onClose,
    onSuccess,
    userId,
    ShowNotificationError,
    setOrder,
    setOrderBy,
    GetListUserManagement,
    rowsPerPage,
    showLoading,
  } = props;

  const [userModel, setUserModel] = useState();
  const [avatar, setAvatar] = useState();
  const [file, setFiles] = useState("");
  const [sex, setSex] = useState(true);
  const [selectedDate, setSelectedDate] = useState(null);
  const [roleId, setRoleId] = useState(null);
  const [roleLockup, setRoleLockup] = useState();

  useEffect(() => {
    onGetAllData();
  }, []);

  const onGetAllData = () => {
    showLoading(true);
    Promise.all([
      GetDetailUserManagement(userId),
      GetRoleLookupUserManagement(),
    ])
      .then((res) => {
        const [userModel, roleLockup] = res;
        setUserModel(userModel && userModel.content ? userModel.content : []);
        if (userModel && userModel.content) {
          setSelectedDate(userModel.content.dateOfBirth);
          setAvatar(userModel.content.avatar);
          setRoleId(userModel.content.roleId);
          setSex(userModel.content.sex);
        }
        setRoleLockup(
          roleLockup && roleLockup.content ? roleLockup.content : []
        );
        showLoading(false);
      })
      .catch((err) => {
        showLoading(false);
      });
  };

  const GetDetailUserManagement = (userId) => {
    return new Promise((resolve, reject) => {
      userManagementAction.GetDetailUserManagement(userId).then(
        (res) => {
          resolve(res);
        },
        (err) => {
          reject(err);
          err &&
            err.errorType &&
            ShowNotification(
              viVN.Errors[err.errorType],
              NotificationMessageType.Error
            );
        }
      );
    });
  };

  const GetRoleLookupUserManagement = () => {
    return new Promise((resolve, reject) => {
      userManagementAction.GetRoleLookupUserManagement().then(
        (res) => {
          resolve(res);
        },
        (err) => {
          reject(err);
          err &&
            err.errorType &&
            ShowNotification(
              viVN.Errors[err.errorType],
              NotificationMessageType.Error
            );
        }
      );
    });
  };

  const { register, handleSubmit, errors, setValue } = useForm({
    mode: "all",
    reValidateMode: "onBlur",
  });

  const onSubmit = (data) => {
    if (!data) {
      return;
    }
    let formData = new FormData();
    formData.append("Id", userId);
    formData.append("FullName", data.fullName);
    formData.append("Email", data.email);
    formData.append("RoleId", roleId);
    formData.append("DateOfBirth", selectedDate);
    formData.append("Sex", sex);
    formData.append("Address", data.address);
    formData.append("Avatar", avatar);
    formData.append("file", file);
    formData.append("Description", data.content);
    formData.append("PhoneNumber", data.phoneNumber);
    userManagementAction
      .UpdateUserManagement(formData)
      .then((result) => {
        if (result) {
          setOrder("desc");
          setOrderBy("modifiedDate");
          GetListUserManagement(1, rowsPerPage);
          onSuccess();
          ShowNotification(
            viVN.Success.UserEditSuccess,
            NotificationMessageType.Success
          );
        }
      })
      .catch((err) => {
        onSuccess();
        ShowNotification(
          viVN.Errors[err.errorType],
          NotificationMessageType.Error
        );
      });
  };

  const customMessages = (rejectFiles) => {
    if (rejectFiles.size > configCommon.Configs.DefaultCapacityFile) {
      ShowNotificationError("Kích thước file phải nhỏ hơn 5MB!");
    } else if (
      rejectFiles.type === "image/*" &&
      (rejectFiles.type === "image/jpeg" ||
        rejectFiles.type === "image/png" ||
        rejectFiles.type === "image/jpg" ||
        rejectFiles.type === "image/gif")
    ) {
      ShowNotificationError("Ảnh nhập vào không đúng định dạng");
    } else {
      ShowNotificationError("File nhập vào phải là ảnh");
    }
  };

  const handleChange = (files) => {
    if (files) {
      setFiles(files[0]);
    }
  };

  function handleChangeSelectSex(event) {
    setSex(event.target.value);
  }

  function handleChangeSelect(event) {
    setRoleId(event.target.value);
  }

  const handleDateChange = (date) => {
    setSelectedDate(dateformat(date, "yyyy-mm-dd"));
  };

  return (
    <div>
      <Dialog open={isOpen} onClose={onClose} fullWidth={true} maxWidth="md">
        <DialogTitle disableTypography className="border-bottom">
          <Typography variant="h6">Chỉnh sửa Người dùng</Typography>
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={onClose}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
          {userModel && (
            <DialogContent className="pt-4 pb-2">
              <div className="form-group">
                <div className="row">
                  <div className="col-12 col-md-6 col-lg-6">
                    <label className="text-dark">
                      Họ và tên<span className="required"></span>
                    </label>
                    <TextField
                      type="text"
                      name="fullName"
                      className="w-100"
                      inputRef={register({ required: true, maxLength: 50 })}
                      defaultValue={userModel.fullName}
                      error={
                        errors.fullName && errors.fullName.type === "required"
                      }
                    />
                    {errors.fullName && errors.fullName.type === "required" && (
                      <span className="error">Trường này là bắt buộc</span>
                    )}
                  </div>
                  <div className="col-12 col-md-6 col-lg-6">
                    <label className="text-dark">Email</label>
                    <TextField
                      type="text"
                      name="email"
                      className="w-100"
                      defaultValue={userModel.email}
                      inputRef={register}
                      disabled
                    />
                  </div>
                </div>
              </div>
              <div className="form-group">
                <div className="row">
                  <div className="col-12 col-md-6 col-lg-6">
                    <label className="text-dark">Chức vụ</label>
                    <br />
                    <Select
                      className="w-100"
                      value={roleId}
                      onChange={handleChangeSelect}
                    >
                      {roleLockup &&
                        roleLockup.length > 0 &&
                        roleLockup.map((items) => (
                          <MenuItem value={items.id}>{items.name}</MenuItem>
                        ))}
                    </Select>
                  </div>
                  <div className="col-12 col-md-6 col-lg-6">
                    <label className="text-dark">Ngày sinh</label>
                    <MuiPickersUtilsProvider
                      utils={DateFnsUtils}
                      locale={viLocale}
                    >
                      <DatePicker
                        id="dateTime"
                        name="startDate"
                        onChange={(date) => date && handleDateChange(date)}
                        format="dd/MM/yyyy"
                        value={selectedDate}
                        fullWidth
                        showTodayButton={true}
                        error={
                          errors.startDate &&
                          errors.startDate.type === "required"
                        }
                      />
                    </MuiPickersUtilsProvider>
                  </div>
                </div>
              </div>

              <div className="form-group">
                <div className="row">
                  <div className="col-12 col-md-6 col-lg-6">
                    <label className="text-dark">Giới tính</label>
                    <br />
                    <Select
                      className="w-100"
                      value={sex}
                      onChange={handleChangeSelectSex}
                    >
                      <MenuItem value={true}>Nam</MenuItem>
                      <MenuItem value={false}>Nữ</MenuItem>
                    </Select>
                  </div>

                  <div className="col-12 col-md-6 col-lg-6">
                    <label className="text-dark">Số điện thoại</label>
                    <TextField
                      type="text"
                      name="phoneNumber"
                      defaultValue={userModel.phoneNumber}
                      className="w-100"
                      inputRef={register}
                      onChange={(e) =>
                        setValue(
                          "phoneNumber",
                          e.target.value.replace(/[^0-9]/g, "")
                        )
                      }
                    />
                  </div>
                </div>
              </div>

              <div className="form-group">
                <div className="row">
                  <div className="col-12 col-md-6 col-lg-6">
                    <label className="text-dark">Địa chỉ</label>
                    <TextField
                      inputRef={register}
                      defaultValue={userModel.address}
                      type="text"
                      name="address"
                      className="w-100"
                    />
                  </div>
                </div>
              </div>

              <div className="form-group">
                <label className="text-dark">Mô tả</label>
                <TextareaAutosize
                  name="content"
                  defaultValue={userModel.description}
                  rowsMin={3}
                  className={"form-control"}
                  ref={register}
                />
              </div>
              <div className="form-group">
                <label className="text-dark">
                  Ảnh (Ảnh nhập vào nhỏ hơn 5MB)
                </label>
                <DropzoneArea
                  className="dropzoneClass"
                  acceptedFiles={[
                    "image/jpeg",
                    "image/png",
                    "image/jpg",
                    "image/gif",
                  ]}
                  showAlerts={false}
                  filesLimit={1}
                  initialFiles={[config.APIUrlDefault + userModel.avatar]}
                  getDropRejectMessage={(rejectedFile) =>
                    customMessages(rejectedFile)
                  }
                  getFileLimitExceedMessage={(filesLimit) =>
                    ShowNotification(
                      `Nhiều nhất ${filesLimit} ảnh`,
                      NotificationMessageType.Error
                    )
                  }
                  dropzoneText={"Chọn ảnh"}
                  onChange={handleChange}
                />
              </div>
            </DialogContent>
          )}

          <DialogActions className="border-top">
            <Button
              type="button"
              onClick={onClose}
              variant="contained"
              startIcon={<CloseIcon />}
            >
              Hủy
            </Button>
            <Button
              type="submit"
              color="primary"
              variant="contained"
              startIcon={<SaveIcon />}
            >
              Lưu
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  );
}
